import React from 'react';

import StreamlitWrapper from '../StreamlitWrapper';

export const MarketingQA = () => <StreamlitWrapper url="https://marketing-qa-application-staging-nyc1.rockerboxmedia.com/" />;
export const ImpressionQA = () => <StreamlitWrapper url="https://impression-qa-application-staging-nyc1.rockerboxmedia.com/" />;
export const WebhooksQA = () => <StreamlitWrapper url="https://webhooks-qa-application-staging-nyc1.rockerboxmedia.com/" />;
export const ModelExplorer = () => <StreamlitWrapper url="https://mta-model-explorer-application-staging-nyc1.rockerboxmedia.com/" />;
